import { NotificationPreferencesContainer } from './NotificationPreferencesContainer';
import { NotificationPreferencesContent } from './NotificationPreferencesContent';
import {
  NotificationPreferencesControlsContainer,
  NotificationPreferencesControlSection,
  NotificationsPreferencesControlTitle,
  NotificationsPreferencesControlToggle,
} from './NotificationPreferencesControl';
import { NotificationPreferencesNotice } from './NotificationPreferencesNotice';
import { NotificationPreferencesSkeleton } from './NotificationPreferencesSkeleton';
import { NotificationPreferencesSubtitle } from './NotificationPreferencesSubtitle';
import { NotificationPreferencesTitle } from './NotificationPreferencesTitle';

// ─────────────────────────────────────────────────────────────────────

export const NotificationPreferences = {
  Container: NotificationPreferencesContainer,
  Content: NotificationPreferencesContent,
  Title: NotificationPreferencesTitle,
  Subtitle: NotificationPreferencesSubtitle,
  Notice: NotificationPreferencesNotice,
  Skeleton: NotificationPreferencesSkeleton,
  Control: {
    Container: NotificationPreferencesControlsContainer,
    Section: NotificationPreferencesControlSection,
    Title: NotificationsPreferencesControlTitle,
    Toggle: NotificationsPreferencesControlToggle,
  },
};
